import React from "react";
import { Form } from "semantic-ui-react";
import { useFormContext } from "react-hook-form";

// Helpers
import { services } from "@common/components/helpers/options/customerIncidentSelect";
import emergencyServicesHelpers from "@common/components/helpers/CustomerIncident/emergencyServicesHelpers";

// Components
import TextareaComponent from "@common/components/shared/forms/TextareaComponent";
import TimeComponent from "@common/components/shared/forms/TimeComponent";
import CheckboxComponent from "@common/components/shared/forms/CheckboxComponent";
import DidNotAttendTimeGroup from "@common/components/shared/forms/DidNotAttendTimeGroup";
import ToggleComponent from "@common/components/shared/forms/ToggleComponent";
import OfficerForm from "@common/components/shared/forms/OfficerForm";

const EmergencyServicesForm = ({
  policeCalled,
  ambulanceCalled,
  eSCalled,
  policeOnly = false,
  didNotAttend,
}) => {
  const methods = useFormContext();
  const {
    control,
    register,
    setValue,
    formState: { errors },
  } = methods;
  const { handleNewOfficer, handleRemoveOfficer } = emergencyServicesHelpers({
    methods,
  });

  return (
    <>
      <ToggleComponent
        control={control}
        name={policeOnly ? "policeInvolved" : "esCalled"}
        label={policeOnly ? "Police Involved" : "Emergency Services Called?"}
        error={policeOnly ? errors.policeInvolved : errors.esCalled}
      />

      {eSCalled && (
        <>
          {!policeOnly && (
            <Form.Group className="py-0_5">
              <Form.Field className="flex-row-center space-between m-0 w-100">
                <CheckboxComponent
                  control={control}
                  name="esTypes"
                  error={errors.esTypes}
                  fieldStyle="flex-row-center m-0"
                  multipleCheckboxes={true}
                  multiData={services}
                />
                {ambulanceCalled && !didNotAttend && (
                  <TextareaComponent
                    name="ambulanceDetails"
                    placeholder="Enter details of the ambulance services that attended (Name & ID Number)"
                    register={register}
                    error={errors.ambulanceDetails}
                    fieldStyle="w-75"
                    rows={3}
                  />
                )}
              </Form.Field>
            </Form.Group>
          )}
          <TimeComponent
            control={control}
            name="timeServicesContacted"
            label={policeOnly ? "Time Police Contacted" : "Time ES Called"}
            error={errors.timeServicesContacted}
            timeContainerStyle="w-25"
          />
          <DidNotAttendTimeGroup
            control={control}
            timeName="timeServicesArrived"
            didNotAttendName="servicesDidNotAttend"
            label={policeOnly ? "Time Police Arrived" : "Time ES Arrived"}
            timeError={errors.timeServicesArrived}
            didNotAttendError={errors.servicesDidNotAttend}
            timeFieldStyle="w-25"
            setValue={setValue}
            didNotAttend={didNotAttend}
          />
          {policeCalled && !didNotAttend && (
            <OfficerForm
              handleNewOfficer={handleNewOfficer}
              handleRemoveOfficer={handleRemoveOfficer}
            />
          )}
        </>
      )}
    </>
  );
};

export default EmergencyServicesForm;
